import {
  findProductAgecWidgetResponseDto,
  type FindProductAgecWidgetResponse,
} from "@tfg/types/schemas/modules/agec/queries/find-product-agec-widget.response.dto"
import type { PartialOrUndefined } from "@tfg/types/schemas/utils"

import { CONFIG } from "../config"

export type ShowWidgetData = {
  show: true
  sheetUrl: NonNullable<FindProductAgecWidgetResponse[number]["sheetUrl"]>
  qrCodeUrl: NonNullable<FindProductAgecWidgetResponse[number]["qrCodeUrl"]>
  productId: NonNullable<FindProductAgecWidgetResponse[number]["productId"]>
  productReference: NonNullable<
    FindProductAgecWidgetResponse[number]["productReference"]
  >
  compliance: NonNullable<FindProductAgecWidgetResponse[number]["compliance"]>
  quantity: NonNullable<FindProductAgecWidgetResponse[number]["quantity"]>
}

export type HideWidgetData = PartialOrUndefined<
  FindProductAgecWidgetResponse[number]
> & {
  show: false
}

export type WidgetData = ShowWidgetData | HideWidgetData

export function isShowWidgetData(
  response: PartialOrUndefined<FindProductAgecWidgetResponse[number]>
): response is ShowWidgetData {
  return "sheetUrl" in response && !!response.sheetUrl && !!response.show
}

export class APIService {
  static async fetchWidgetData(
    productCode: string,
    apiKey: string
  ): Promise<ShowWidgetData | HideWidgetData> {
    try {
      const url = new URL(CONFIG.API_BASE_URL)
      if (!url.pathname.endsWith("/")) url.pathname += "/"
      url.pathname += "products-agec/widget"
      url.searchParams.set("reference", productCode)

      const response = await fetch(url, { headers: { "x-api-key": apiKey } })
      if (!response.ok) {
        throw new Error("API request failed")
      }

      const data = findProductAgecWidgetResponseDto.parse(await response.json())

      return this.mapAPIResponseToWidgetData(data)
    } catch (error) {
      console.error("Error fetching widget data:", error)
      return { show: false }
    }
  }

  static mapAPIResponseToWidgetData(
    response: FindProductAgecWidgetResponse
  ): WidgetData {
    return (
      response
        .filter(isShowWidgetData)
        .sort((a, b) => (b.quantity || 0) - (a.quantity || 0))
        .find((item) => item.show) || { show: false }
    )
  }
}
